import { cn } from "@/lib/utils";
import { APP_NAME, BRAND_LOGO } from "@/lib/brand";

type BrandLogoMarkProps = {
  className?: string;
  size?: number;
};

/**
 * App mark: invoice (left) + plus (right) on Hanaro green.
 * Reads clearly from 16px favicon up to login hero size.
 */
export function BrandLogoMark({ className, size = 20 }: BrandLogoMarkProps) {
  const { bg, ink } = BRAND_LOGO;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      width={size}
      height={size}
      className={cn("shrink-0", className)}
      aria-hidden
    >
      <rect width="32" height="32" rx="8" fill={bg} />
      <rect x="4" y="6" width="15" height="20" rx="2.5" fill={ink} />
      <rect x="7" y="11" width="9" height="2.5" rx="1.25" fill={bg} />
      <rect x="7" y="16" width="6.5" height="2.5" rx="1.25" fill={bg} />
      <rect x="21" y="14.25" width="8" height="3.5" rx="1.75" fill={ink} />
      <rect x="23.25" y="12" width="3.5" height="8" rx="1.75" fill={ink} />
    </svg>
  );
}

type BrandLogoLockupProps = {
  className?: string;
  iconSize?: number;
  showName?: boolean;
};

/** Icon + wordmark for login and marketing surfaces. */
export function BrandLogoLockup({
  className,
  iconSize = 48,
  showName = true,
}: BrandLogoLockupProps) {
  return (
    <div className={cn("flex flex-col items-center gap-3 text-center", className)}>
      <BrandLogoMark size={iconSize} />
      {showName ? (
        <p className="text-xl font-semibold tracking-tight">{APP_NAME}</p>
      ) : null}
    </div>
  );
}
